import * as actions from './actions';
import * as reducers from './reducers';
import sagas from './sagas';
export { default as ModelsRoute } from './ModelsRoute';

export default {
	actions,
	reducers,
	sagas
};
